import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import { toast } from "sonner";
import { Save } from "lucide-react";

export default function AdminSettings() {
  const [p, setP] = useState(null);

  useEffect(() => { api.get("/admin/property").then((r) => setP(r.data)); }, []);

  const save = async () => {
    try {
      await api.put("/admin/property", {
        ...p,
        monthly_rent: Number(p.monthly_rent),
        security_deposit: p.security_deposit === "" || p.security_deposit == null ? null : Number(p.security_deposit),
        bedrooms: Number(p.bedrooms),
        bathrooms: Number(p.bathrooms),
      });
      toast.success("Saved");
    } catch (e) { toast.error("Failed: " + (e?.response?.data?.detail || e.message)); }
  };
  if (!p) return <div className="p-8" style={{ color: "#475569" }}>Loading…</div>;
  const set = (k) => (e) => setP({ ...p, [k]: e.target.value });
  return (
    <div className="p-4 sm:p-8 max-w-3xl mx-auto">
      <h1 className="font-serif text-3xl" style={{ color: "#0B2D59" }}>Property settings</h1>
      <p className="text-sm" style={{ color: "#475569" }}>These values appear on the public landing page.</p>
      <div className="p2p-card p-6 mt-5 grid sm:grid-cols-2 gap-4">
        <Field label="Monthly rent ($)"><input type="number" className="p2p-input" data-testid={ADMIN.property.rent} value={p.monthly_rent} onChange={set("monthly_rent")} /></Field>
        <Field label="Security deposit ($) — leave blank to show “Negotiable”"><input type="text" inputMode="decimal" className="p2p-input" data-testid={ADMIN.property.deposit} placeholder="Negotiable" value={p.security_deposit ?? ""} onChange={set("security_deposit")} /></Field>
        <Field label="Availability date"><input type="date" className="p2p-input" data-testid={ADMIN.property.availability} value={p.availability_date} onChange={set("availability_date")} /></Field>
        <Field label="Bedrooms"><input type="number" className="p2p-input" value={p.bedrooms} onChange={set("bedrooms")} /></Field>
        <Field label="Bathrooms"><input type="number" step="0.5" className="p2p-input" value={p.bathrooms} onChange={set("bathrooms")} /></Field>
        <Field label="Address" wide><input className="p2p-input" value={p.address} onChange={set("address")} /></Field>
        <Field label="Utilities note" wide><textarea rows={2} className="p2p-input" data-testid={ADMIN.property.utilities} value={p.utilities_note} onChange={set("utilities_note")} /></Field>
        <Field label="Other notes" wide><textarea rows={2} className="p2p-input" value={p.extra_notes || ""} onChange={set("extra_notes")} /></Field>
        <Field label="Contact phone (shown to applicants)"><input className="p2p-input" value={p.contact_phone || ""} onChange={set("contact_phone")} data-testid="admin-prop-phone" /></Field>
        <Field label="Contact email (shown to applicants)"><input type="email" className="p2p-input" value={p.contact_email || ""} onChange={set("contact_email")} data-testid="admin-prop-email" /></Field>
      </div>
      <button className="p2p-btn-primary mt-5 inline-flex items-center gap-2" data-testid={ADMIN.property.save} onClick={save}>
        <Save className="w-4 h-4" /> Save
      </button>
    </div>
  );
}

function Field({ label, children, wide }) {
  return (
    <label className={wide ? "sm:col-span-2 block" : "block"}>
      <span className="p2p-label">{label}</span>
      {children}
    </label>
  );
}
